// components/M2TMobileNativeChart.jsx

import React from "react";
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Area, AreaChart,
} from "recharts";

// Sample market data (real chart will get data from API)
const data = [
  { time: "09:00", price: 2355.6 },
  { time: "10:00", price: 2362.2 },
  { time: "11:00", price: 2375.0 },
  { time: "12:00", price: 2368.5 },
  { time: "13:00", price: 2382.8 },
  { time: "14:00", price: 2390.1 },
  { time: "15:00", price: 2387.7 },
];

// Custom tooltip for mobile-native feel
function ChartTooltip({ active, payload }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-black/80 rounded px-2 py-1 text-xs text-yellow-200 shadow">
      <div>Price: <b>{payload[0].value}</b></div>
      <div className="text-slate-400">{payload[0].payload.time}</div>
    </div>
  );
}

export default function M2TMobileNativeChart({
  height = 160,
  showArea = true,
  color = "#38bdf8",  // Tailwind sky-400
}) {
  return (
    <div
      className="rounded-xl shadow bg-[#151d27] p-2"
      style={{
        minHeight: height,
        maxWidth: 380,
        width: "100%",
        touchAction: "pan-x", // enable mobile touch scroll
      }}
    >
      <ResponsiveContainer width="100%" height={height}>
        {showArea ? (
          <AreaChart data={data}>
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.35} />
                <stop offset="95%" stopColor={color} stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="time"
              tick={{ fontSize: 10, fill: "#aaa" }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 10, fill: "#aaa" }}
              axisLine={false}
              tickLine={false}
              width={38}
              domain={["auto", "auto"]}
            />
            <Tooltip content={<ChartTooltip />} cursor={{ fill: "#38bdf822" }} />
            <Area
              type="monotone"
              dataKey="price"
              stroke={color}
              fillOpacity={1}
              fill="url(#colorUv)"
              strokeWidth={2.5}
              activeDot={{ r: 4, fill: color, stroke: "#fff", strokeWidth: 2 }}
              isAnimationActive={true}
            />
          </AreaChart>
        ) : (
          <LineChart data={data}>
            <XAxis dataKey="time" tick={{ fontSize: 10, fill: "#aaa" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 10, fill: "#aaa" }} axisLine={false} tickLine={false} width={38} />
            <Tooltip content={<ChartTooltip />} cursor={{ fill: "#38bdf822" }} />
            <Line
              type="monotone"
              dataKey="price"
              stroke={color}
              strokeWidth={2.5}
              dot={false}
              activeDot={{ r: 4, fill: color, stroke: "#fff", strokeWidth: 2 }}
              isAnimationActive={true}
            />
          </LineChart>
        )}
      </ResponsiveContainer>
    </div>
  );
}
